import { z } from "zod";
import { SeatingCanvasInsetSchema } from "./seating-canvas";
export const GuestPlanSeatingSchema = z.object({
    tableId: z.string().nullable(),
    seatNumber: z.number().int().nullable(),
});
export const SeatingPlanSchema = z.object({
    id: z.string(),
    name: z.string().min(1).max(60),
    seatingCanvasInset: SeatingCanvasInsetSchema.optional(),
    seatingRoomWidthM: z.number().positive().optional(),
    /** Public share token id (matches `/seatingTokens/{token}`); null when sharing disabled. */
    shareToken: z.string().nullable().optional(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const SEATING_PLAN_NAME_MAX = 60;
/** Firestore dot-path for per-plan guest assignment updates. */
export function guestSeatingFieldPath(planId) {
    return `seatingByPlan.${planId}`;
}
const UNASSIGNED = { tableId: null, seatNumber: null };
/**
 * Resolve a guest's table/seat for a specific seating plan version.
 * Legacy flat `tableId`/`seatNumber` applies only to the migrated default plan.
 */
export function guestSeatingForPlan(guest, planId, legacyPlanId) {
    if (!planId)
        return UNASSIGNED;
    const byPlan = guest.seatingByPlan?.[planId];
    if (byPlan !== undefined) {
        return {
            tableId: byPlan.tableId ?? null,
            seatNumber: byPlan.seatNumber ?? null,
        };
    }
    if (legacyPlanId && planId === legacyPlanId && guest.tableId) {
        return {
            tableId: guest.tableId,
            seatNumber: guest.seatNumber ?? null,
        };
    }
    return UNASSIGNED;
}
export function isGuestAssignedInPlan(guest, planId, legacyPlanId) {
    return guestSeatingForPlan(guest, planId, legacyPlanId).tableId != null;
}
